import React, { useState } from 'react'
import "./Faq.css"
import { Faqdata } from './Faqdata'
import { TfiLayoutLineSolid } from "react-icons/tfi";

const Faq = () => {

    const data = Faqdata
    const [open, setopen] = useState(null)

    const togglefaq = (i) => {
        if (open === i) {
            return setopen(null)
        }
        setopen(i);
    }
    return (
        <div className="Faq-main">
            <div className="faq-text">
                <span><TfiLayoutLineSolid />Questions</span>
                <h1>Before you open the ledger.</h1>
            </div>
            <div className='container'>
                {data.map((item, i) => {
                    return (

                        <div className="faq-accordion" onClick={() => togglefaq(i)} >
                            <div className="title">
                                <h2>{item.Question}</h2>
                                <span>{open === i ? "-" : "+"}</span>
                            </div>
                            <div className={open === i ? "content show" : "content"}>
                                {item.Answer}
                            </div>
                        </div>

                    )
                })}
            </div>
        </div>
    )
}

export default Faq